import React, { useEffect } from 'react'
import { Select } from 'antd'
import { toast } from 'react-toastify'
import { useListContentTypesQuery } from '../redux/Api/UserManagment/uMUsersContentTypesApiSlice'

const ContentTypesDropdown = ({ onChange, onBlur, value, multi = true }) => {
  const { data, isLoading, error } = useListContentTypesQuery({
    page: '*',
    ordering: 'app_label',
    fields: 'id,app_label,model'
  })
  let options = []

  if (data) {
    options = data.map(item => {
      return {
        label: item.app_label + ' - ' + item.model,
        value: item.id
      }
    })
  }
  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [error])

  return (
    <div className=' mb-3'>
      <label className=''>Content Type</label>
      <br />
      <Select
        mode={multi ? 'multiple' : ''}
        allowClear
        style={{
          width: '100%'
        }}
        optionFilterProp='label'
        loading={isLoading}
        placeholder='Please select'
        onBlur={onBlur}
        value={value}
        onChange={e => onChange('content_type', e)}
        options={options}
      />
    </div>
  )
}

export default ContentTypesDropdown
